import script from "./AnalysisYear.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisYear.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisYear.vue?vue&type=style&index=0&id=322b3b7a&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322b3b7a"]])

export default __exports__